<template>
  <div>
    <btn-cancel
      :text="buttonLabel || $t('support.components.filterComponent.template.ctaBtnFilter')"
      block
      v-bind="$attrs"
      @click="dialog = true"
    />
    <sidebar-dialog
      v-model="dialog"
      :title="title || $t('support.components.filterComponent.template.title')"
    >
      <v-form
        ref="filterTemplateForm"
        class="fill-height"
        @submit.prevent="filter()"
      >
        <v-layout
          column
          wrap
          fill-height
          align-center
          justify-space-between
        >
          <slot />
          <v-spacer />
        </v-layout>
        <v-flex
          sm12
        >
          <btn-primary
            id="submit"
            :text="$t('support.components.filterComponent.template.btnApply')"
            type="submit"
            block
            class="mb-4"
          />
          <btn-cancel
            id="cancel"
            :text="$t('support.components.filterComponent.template.btnClear')"
            block
            @click="clearFilter()"
          />
        </v-flex>
      </v-form>
    </sidebar-dialog>
  </div>
</template>

<script>
import SidebarDialog from 'Support/components/filter-component/SidebarDialog.vue';
import BtnCancel from 'Support/components/buttons/BtnCancel.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';

export default {
  name: 'FilterTemplate',
  components: { SidebarDialog, BtnCancel, BtnPrimary },
  props: {
    title: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    filter() {
      if (!this.$refs.filterTemplateForm.validate()) {
        return;
      }
      this.$emit('submit');
      this.dialog = false;
    },
    clearFilter() {
      this.$emit('clear');
    },
  },
};
</script>
<style>
.sidebarDialog {
  background: white !important;
  border-radius: 4px !important;
  box-shadow: 2px 1px 10px rgba(15, 15, 15, 0.15) !important;
  height: 100% !important;
  left: 300px !important;
  margin: 0 !important;
  max-height: 100% !important;
  padding: 0 !important;
  position: fixed !important;
  top: 0 !important;
  width: 444px !important;
}
.v-dialog.sidebarDialog.v-dialog--active {
  display: flex !important;
  flex-direction: column !important;
}
</style>
